import React, { Component } from 'react';
import '../../../App.css';
import '../../../styles/app-demo.css';
import fintwistLogo from '../../../assets/mobile-app/Fintwist_Logo_Full_Color_RGB.png';

class AccountsOverview extends Component {

  render() {

    return (
      <div id="dashboard-accounts">
        <div id="dashboard-account-separator">
          <i onClick={() => {this.props.toggleTransactionPreview()}} className="fa fa-angle-down"></i>
          <p>Accounts</p>
        </div>
        <div onClick={() => {this.props.toggleNewRoute('transactions')}} id="home-account-list">
          <div className="home-account-list-row" id="row-1">
            <p>Fintwist Account</p>
            <p>$1,834.00</p>
          </div>
          <div className="home-account-list-row" id="row-2">
            <p>Comdata</p>
            <p>Available Balance</p>
          </div>
        </div>
        <div id="home-manage-cards-link-section">
          <p onClick={() => {this.props.toggleNewRoute('card management')}}>MANAGE CARDS</p>
        </div>
        <img className="fintwist-logo" src={fintwistLogo} alt={'' }/>
      </div>
    );
  }
}

export default AccountsOverview;
